import en from './languages/en.json'
import ja from './languages/ja.json'

export default {
  en,
  ja,
}
